export default "__VITE_ASSET__t$mVdMvt__"